import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import useGetServicesContext from "../../../Hooks/ContextHooks/General/useGetServicesContext";
import useReligionTaxContext from "../../../Hooks/ContextHooks/Main/useReligionTaxContext";
import useShowModalContext from "../../../Hooks/ContextHooks/General/useShowModalContext";

const validationSchema = Yup.object({
  for: Yup.string().required("This field is required"),
  count: Yup.number()
    .required("This field is required")
    .positive("Count must be a positive number ( > 0 )"),
  owner: Yup.string().required("This field is required"),
  amount: Yup.number()
    .required("his field is required")
    .positive("Amount must be a positive number ( > 0 )"),
});

const initialValues = {
  for: "",
  type: "",
  count: "",
  owner: "",
  amount: "",
};

const religiousFunds = [
  { name: "Zakat", amount: 0 },
  { name: "Khums", amount: 0 },
  { name: "Sadaqah", amount: 0 },
  { name: "Waqf", amount: 0 },
  { name: "Fitrah", amount: 0 },
  { name: "Qurbani", amount: 0 },
  { name: "Fitrana", amount: 0 },
  { name: "Nazar", amount: 0 },
  { name: "Aqiqah", amount: 0 },
];

function ReligionModalForm() {
    const { servicesArray } = useGetServicesContext();
    const { setReligionItems } = useReligionTaxContext()
    const {setShowModal} = useShowModalContext()

  const onSubmit = (values, { resetForm }) => {
    setReligionItems(prev => [ ...prev, values ])
    setShowModal(false)
    resetForm();
  };

  return (
    <div className="container">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <Form>
            <div className="container mt-5 mb-4">
              <div className="row">
                <div className="col-me-12">
                  <div className="form-group mb-3">
                    <Field as="select" name="type" className="form-select">
                      <option value="">Select an type</option>
                      {religiousFunds.map((r, i) => {
                        return (
                          <option value={r.name} key={i}>
                            {r.name}
                          </option>
                        );
                      })}
                    </Field>
                    <ErrorMessage
                      name="type"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <div className="form-group mb-3">
                    <Field as="select" name="for" className="form-select">
                      <option value="">Select a for</option>
                      {servicesArray &&
                        servicesArray?.map((service, i) => {
                          return (
                            <option value={service?.localContent[0]?.title} key={i}>
                              {service?.localContent[0]?.title}
                            </option>
                          );
                        })}
                    </Field>
                    <ErrorMessage
                      name="for"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <div className="form-group mb-3">
                    <Field
                      type="number"
                      name="count"
                      className="form-control"
                      placeholder="Enter count here..."
                    />
                    <ErrorMessage
                      name="count"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <div className="form-group mb-3">
                    <Field
                      type="text"
                      name="owner"
                      className="form-control"
                      placeholder="Owner name here..."
                    />
                    <ErrorMessage
                      name="owner"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <div className="form-group mb-3">
                    <Field
                      type="number"
                      name="amount"
                      className="form-control"
                      placeholder="Amount in Afghani..."
                    />
                    <ErrorMessage
                      name="amount"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </div>
              </div>
              <div className="text-end mt-3">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm mx-2 text-end"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn web-btn btn-sm mx-2 text-end"
                >
                  Save
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ReligionModalForm;
